import { ROUTES_PARTNERS } from '@/app/data/route_constants';
import routesDecision from '@/router/partner/routes-decision';
import routesIssueListType from '@/router/partner/routes-issue-list-type';
import routesIssueList from '@/router/partner/routes-issue-list';
import { FILTER_SCOPES } from '@/app/data/filter_constants.js';

const partnerRoutes = [
  {
    name: ROUTES_PARTNERS.CLIENT_DASHBOARD,
    path: 'dashboard',
    component: () => import('@/app/_partners/pages/DashboardPage.vue'),
  },
  {
    name: ROUTES_PARTNERS.PROJECT,
    path: 'project/:project_id/',
    component: () => import('@/app/shared_components/Project.vue'),
    props: true,
    children: [
      {
        path: 'decisions_types',
        component: () => import('@/app/_partners/pages/DecisionTypesPage.vue'),
        props: true,
        children: [
          {
            name: ROUTES_PARTNERS.PROJECT_DECISION_TYPES,
            path: '',
            component: () => import('@/app/_partners/pages/DecisionTypesListPage.vue'),
            props: true,
          },
          {
            name: ROUTES_PARTNERS.PROJECT_DECISION_TYPES_MATRIX,
            path: 'matrix',
            component: () => import('@/app/_partners/pages/DecisionTypesMatrixPage.vue'),
            props: true,
          },
        ],
      },
      {
        name: ROUTES_PARTNERS.PROJECT_DECISIONS,
        path: 'decision_type/:decision_type_id',
        component: () => import('@/app/_partners/pages/DecisionsPage.vue'),
        props: true,
      },
      {
        name: ROUTES_PARTNERS.PROJECT_TICKETS,
        path: 'tickets',
        component: () => import('@/app/_partners/pages/TicketsPage.vue'),
        props: true,
        meta: { filter_scope: FILTER_SCOPES.TICKETS_PROJECT },
      },
      {
        name: ROUTES_PARTNERS.PROJECT_TICKETS_SHOW,
        path: 'tickets/:ticket_id',
        component: () => import('@/app/_partners/pages/TicketPage.vue'),
        props: true,
      },
      {
        path: 'decision_type',
        redirect: { name: ROUTES_PARTNERS.PROJECT_DECISION_TYPES },
      },
      {
        path: 'decision/:decision_id/',
        component: () => import('@/app/_partners/pages/DecisionPage.vue'),
        props: true,
        children: routesDecision,
      },
      {
        path: 'decision',
        redirect: { name: ROUTES_PARTNERS.PROJECT_DECISION_TYPES },
      },
      {
        name: ROUTES_PARTNERS.PROJECT_DOCUMENTS,
        path: 'documents/:level_type?/:level_id?',
        component: () => import('@/app/_partners/pages/DocumentsPage.vue'),
        meta: { filter_scope: FILTER_SCOPES.DOCUMENTS_INFO },
      },
      {
        name: ROUTES_PARTNERS.PROJECT_ISSUE_LIST_TYPES,
        path: 'issue_list_types',
        component: () => import('@/app/_partners/pages/IssueListTypesPage.vue'),
        props: true,
      },

      {
        name: ROUTES_PARTNERS.PROJECT_ISSUE_LIST_TYPE,
        path: 'issue_list_types/:issue_list_type_id/',
        component: () => import('@/app/_partners/pages/IssueListTypePage.vue'),
        children: routesIssueListType,
        props: true,
      },
      {
        name: ROUTES_PARTNERS.PROJECT_ISSUE_LIST,
        path: 'issue_list_types/:issue_list_type_id/issue_list/:issue_list_id',
        component: () => import('@/app/_partners/pages/IssueListPage.vue'),
        children: routesIssueList,
        props: true,
      },
    ],
  },
  {
    name: ROUTES_PARTNERS.SETTINGS_PROFILE,
    path: 'settings/profile',
    component: () => import('@/app/_partners/pages/SettingsPartnerPage.vue'),
  },
];

export default partnerRoutes;
